import { render, staticRenderFns } from "./BossIdImageField.vue?vue&type=template&id=5127dfe8&scoped=true"
import script from "./BossIdImageField.vue?vue&type=script&lang=ts"
export * from "./BossIdImageField.vue?vue&type=script&lang=ts"
import style0 from "./BossIdImageField.vue?vue&type=style&index=0&id=5127dfe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127dfe8",
  null
  
)

export default component.exports